export const post = (accessToken, uri) => {
  return executeImpl("POST", accessToken, uri);
};

export const get = (accessToken, uri) => {
  return executeImpl("GET", accessToken, uri);
};

const executeImpl = (method, accessToken, uri) => {
  const options = {
    method: method,
    headers: new Headers({
      "Content-Type": "application/json",
    }),
  };

  if (accessToken)
    options.headers.append("Authorization", "Bearer " + accessToken);
  return fetch(uri, options);
};
